import React, { ReactElement, useEffect, useState } from 'react';
import CcxComponentProps from '../../../../core/CcxComponent';
import { Col, Row, Space } from 'antd';
import styles from './DataStoreOverview.module.less';
import DataStoreOverviewGeneralInformation from './DataStoreOverviewGeneralInformation';
import { useParams } from 'react-router';
import DeploymentsItem from '../../../../types/DeploymentsItem';
import DataStoreOverviewServicesState from './DataStoreOverviewServicesState';
import DataStoreOverviewNetworkInformation from './DataStoreOverviewNetworkInformation';
import DataStoreOverviewCloudInformation from './DataStoreOverviewCloudInformation';
import useDataStoreServices from '../../../../core/hooks/useDataStoreServices';
import useDataStores from '../../../../core/hooks/useDataStores';
import DataStoreOverviewQueriesPerSecond from './DataStoreOverviewQueriesPerSecond';

interface UrlProps {
    dataStoreUuid: string;
}

interface Props extends CcxComponentProps {}

function DataStoreOverview({
    testId = 'DataStoreOverview',
}: Props): ReactElement {
    let { dataStoreUuid } = useParams<UrlProps>();
    const { dataStores } = useDataStores('default');
    const [dataStore, setDataStore] = useState<DeploymentsItem | undefined>(
        undefined
    );
    const { services } = useDataStoreServices({
        dataStoreUuid,
    });

    useEffect(() => {
        if (dataStores) {
            const currentDataStore = dataStores?.getByUuid(dataStoreUuid);
            if (currentDataStore) setDataStore(currentDataStore);
        }
    }, [dataStores, dataStoreUuid]);

    return (
        <div className={styles.DataStoreOverview} data-testid={testId}>
            <Row gutter={16}>
                <Col span={12}>
                    <Space
                        direction="vertical"
                        size="middle"
                        className={styles.DataStoreOverviewSpace}
                    >
                        <DataStoreOverviewServicesState
                            dataStore={dataStore}
                            services={services}
                        />
                        <DataStoreOverviewGeneralInformation
                            dataStore={dataStore}
                        />
                    </Space>
                </Col>
                <Col span={12}>
                    <Space
                        direction="vertical"
                        size="middle"
                        className={styles.DataStoreOverviewSpace}
                    >
                        <DataStoreOverviewQueriesPerSecond
                            dataStore={dataStore}
                        />
                        <DataStoreOverviewCloudInformation
                            dataStore={dataStore}
                        />
                        <DataStoreOverviewNetworkInformation
                            dataStore={dataStore}
                        />
                    </Space>
                </Col>
            </Row>
        </div>
    );
}

export default DataStoreOverview;
